export const RADIUSES = {
  SMALL: 8,
  DEFAULT: 12,
  MEDIUM: 16
};
